// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import {
  backgroundTasksTasksRetrieveResponseTransformer,
  directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
  directoutreachPolicyAvailableListResponseTransformer,
  directoutreachPolicyAvailableRetrieveResponseTransformer,
  directoutreachPolicyCreateResponseTransformer,
  directoutreachVotersCreateCreateResponseTransformer,
  directoutreachVotersHoldingsRetrieveResponseTransformer,
  directoutreachVotersSelectedPolicyCreateResponseTransformer,
  directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
  fundManagerFundManagersCreateResponseTransformer,
  fundManagerFundManagersRetrieveResponseTransformer,
  fundManagerFundManagersSearchCreateResponseTransformer,
  fundManagerFundManagersUpdateResponseTransformer,
  fundManagerFundsCreateResponseTransformer,
  fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
  fundManagerFundsRetrieveResponseTransformer,
  fundManagerFundsSearchCreateResponseTransformer,
  fundManagerFundsUpdateResponseTransformer,
  fundManagerFundVariantsCreateResponseTransformer,
  fundManagerFundVariantsRetrieveResponseTransformer,
  fundManagerFundVariantsSearchCreateResponseTransformer,
  fundManagerFundVariantsUpdateResponseTransformer,
  fundManagerProvidersCreateResponseTransformer,
  fundManagerProvidersListResponseTransformer,
  fundManagerProvidersRetrieveResponseTransformer,
  fundManagerProvidersUpdateResponseTransformer,
  fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
  institutionalMeetingsearchListResponseTransformer,
  proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
  proxyvotingEntitlementsListResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
  proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingMeetingBallotsListResponseTransformer,
  proxyvotingMeetingBallotSourcesListResponseTransformer,
  proxyvotingPiballotsFilterListResponseTransformer,
  proxyvotingPimeetingsFilterListResponseTransformer,
  proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
  proxyvotingSviProposalOverwriteCreateResponseTransformer,
  transparencyAuditEventsSearchCreateResponseTransformer,
  transparencyExternalMeetingIdsCreateResponseTransformer,
  transparencyGeneralMeetingsCreateResponseTransformer,
  transparencyGeneralMeetingsPartialUpdateResponseTransformer,
  transparencyGeneralMeetingsRetrieveResponseTransformer,
  transparencyGeneralMeetingsSearchCreateResponseTransformer,
  transparencyOrganizationsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
  transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
  transparencyOrganizationsLogoCreateResponseTransformer,
  transparencyOrganizationsPartialUpdateResponseTransformer,
  transparencyOrganizationsRetrieveResponseTransformer,
  transparencyOrganizationsSearchCreateResponseTransformer,
  transparencyOrganizationsUpdateResponseTransformer,
  transparencyProposalsFetchCreateResponseTransformer,
  transparencyPublicSecurityIdsSearchCreateResponseTransformer,
  votingOperationsPiballotsFilterListResponseTransformer,
  votingOperationsPimeetingsFilterListResponseTransformer,
  votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
  votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsListResponseTransformer,
  votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesRetrieveResponseTransformer,
  votingPolicyVotingPoliciesSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsListResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
  votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
} from './transformers.gen'
import type {
  ApiSchemaRetrieveData,
  ApiSchemaRetrieveResponses,
  BackgroundTasksTasksRetrieveData,
  BackgroundTasksTasksRetrieveErrors,
  BackgroundTasksTasksRetrieveResponses,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  DirectoutreachPolicyAvailableListData,
  DirectoutreachPolicyAvailableListResponses,
  DirectoutreachPolicyAvailableRetrieveData,
  DirectoutreachPolicyAvailableRetrieveResponses,
  DirectoutreachPolicyCreateData,
  DirectoutreachPolicyCreateResponses,
  DirectoutreachVotersBatchCreateCreateData,
  DirectoutreachVotersBatchCreateCreateErrors,
  DirectoutreachVotersBatchCreateCreateResponses,
  DirectoutreachVotersCreateCreateData,
  DirectoutreachVotersCreateCreateResponses,
  DirectoutreachVotersHoldingsRetrieveData,
  DirectoutreachVotersHoldingsRetrieveErrors,
  DirectoutreachVotersHoldingsRetrieveResponses,
  DirectoutreachVotersRetrieveData,
  DirectoutreachVotersRetrieveErrors,
  DirectoutreachVotersRetrieveResponses,
  DirectoutreachVotersSelectedPolicyCreateData,
  DirectoutreachVotersSelectedPolicyCreateErrors,
  DirectoutreachVotersSelectedPolicyCreateResponses,
  DirectoutreachVotersSelectedPolicyRetrieveData,
  DirectoutreachVotersSelectedPolicyRetrieveErrors,
  DirectoutreachVotersSelectedPolicyRetrieveResponses,
  FundManagerFundManagersCreateData,
  FundManagerFundManagersCreateResponses,
  FundManagerFundManagersRetrieveData,
  FundManagerFundManagersRetrieveResponses,
  FundManagerFundManagersSearchCreateData,
  FundManagerFundManagersSearchCreateResponses,
  FundManagerFundManagersUpdateData,
  FundManagerFundManagersUpdateResponses,
  FundManagerFundsCreateData,
  FundManagerFundsCreateResponses,
  FundManagerFundsQuantificationSnapshotsCreateData,
  FundManagerFundsQuantificationSnapshotsCreateResponses,
  FundManagerFundsRetrieveData,
  FundManagerFundsRetrieveResponses,
  FundManagerFundsSearchCreateData,
  FundManagerFundsSearchCreateResponses,
  FundManagerFundsUpdateData,
  FundManagerFundsUpdateResponses,
  FundManagerFundVariantsCreateData,
  FundManagerFundVariantsCreateResponses,
  FundManagerFundVariantsDestroyData,
  FundManagerFundVariantsDestroyResponses,
  FundManagerFundVariantsRetrieveData,
  FundManagerFundVariantsRetrieveResponses,
  FundManagerFundVariantsSearchCreateData,
  FundManagerFundVariantsSearchCreateResponses,
  FundManagerFundVariantsUpdateData,
  FundManagerFundVariantsUpdateResponses,
  FundManagerProvidersCreateData,
  FundManagerProvidersCreateResponses,
  FundManagerProvidersListData,
  FundManagerProvidersListResponses,
  FundManagerProvidersRetrieveData,
  FundManagerProvidersRetrieveResponses,
  FundManagerProvidersUpdateData,
  FundManagerProvidersUpdateResponses,
  FundManagerQuantificationSnapshotsSearchCreateData,
  FundManagerQuantificationSnapshotsSearchCreateResponses,
  InstitutionalMeetingsearchListData,
  InstitutionalMeetingsearchListResponses,
  ProxyIntermediaryProposalCategoriesAssignCreateData,
  ProxyIntermediaryProposalCategoriesAssignCreateResponses,
  ProxyIntermediaryProposalCategoriesListCreateData,
  ProxyIntermediaryProposalCategoriesListCreateResponses,
  ProxyIntermediaryProposalLabelsAssignCreateData,
  ProxyIntermediaryProposalLabelsAssignCreateResponses,
  ProxyIntermediaryProposalLabelsFetchCreateData,
  ProxyIntermediaryProposalLabelsFetchCreateResponses,
  ProxyIntermediaryProxyIntermediariesSearchCreateData,
  ProxyIntermediaryProxyIntermediariesSearchCreateResponses,
  ProxyvotingEntitlementsBreakdownCreateData,
  ProxyvotingEntitlementsBreakdownCreateResponses,
  ProxyvotingEntitlementsComputeCreateData,
  ProxyvotingEntitlementsComputeCreateResponses,
  ProxyvotingEntitlementsListData,
  ProxyvotingEntitlementsListResponses,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesCreateData,
  ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesDestroyData,
  ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  ProxyvotingFundManagerSupportedPoliciesListData,
  ProxyvotingFundManagerSupportedPoliciesListResponses,
  ProxyvotingInvestorCompositionsDifferenceListData,
  ProxyvotingInvestorCompositionsDifferenceListResponses,
  ProxyvotingInvestorCompositionsRenderCreateData,
  ProxyvotingInvestorCompositionsRenderCreateResponses,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingMeetingballotsComputeCreateData,
  ProxyvotingMeetingballotsComputeCreateResponses,
  ProxyvotingMeetingBallotsListData,
  ProxyvotingMeetingBallotsListResponses,
  ProxyvotingMeetingBallotSourcesListData,
  ProxyvotingMeetingBallotSourcesListResponses,
  ProxyvotingPiballotsFilterListData,
  ProxyvotingPiballotsFilterListResponses,
  ProxyvotingPiballotsInvestorsCanVoteCreateData,
  ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  ProxyvotingPimeetingsFilterListData,
  ProxyvotingPimeetingsFilterListResponses,
  ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  ProxyvotingRulesEngineDefinitionsCreateData,
  ProxyvotingRulesEngineDefinitionsCreateResponses,
  ProxyvotingRulesEngineDefinitionsDestroyData,
  ProxyvotingRulesEngineDefinitionsDestroyErrors,
  ProxyvotingRulesEngineDefinitionsDestroyResponses,
  ProxyvotingRulesEngineDefinitionsListData,
  ProxyvotingRulesEngineDefinitionsListResponses,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRetrieveData,
  ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRulesCreateData,
  ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  ProxyvotingRulesEngineDefinitionsRulesListData,
  ProxyvotingRulesEngineDefinitionsRulesListResponses,
  ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  ProxyvotingSviProposalOverwriteCreateData,
  ProxyvotingSviProposalOverwriteCreateResponses,
  ProxyvotingSviProposalOverwriteReasonsListData,
  ProxyvotingSviProposalOverwriteReasonsListResponses,
  TransparencyAuditEventsSearchCreateData,
  TransparencyAuditEventsSearchCreateResponses,
  TransparencyExternalMeetingIdsCreateData,
  TransparencyExternalMeetingIdsCreateResponses,
  TransparencyExternalMeetingIdsDestroyData,
  TransparencyExternalMeetingIdsDestroyResponses,
  TransparencyGeneralMeetingsCreateData,
  TransparencyGeneralMeetingsCreateResponses,
  TransparencyGeneralMeetingsPartialUpdateData,
  TransparencyGeneralMeetingsPartialUpdateResponses,
  TransparencyGeneralMeetingsRetrieveData,
  TransparencyGeneralMeetingsRetrieveResponses,
  TransparencyGeneralMeetingsSearchCreateData,
  TransparencyGeneralMeetingsSearchCreateResponses,
  TransparencyInstrumentsCreateData,
  TransparencyInstrumentsCreateResponses,
  TransparencyInstrumentsDestroyData,
  TransparencyInstrumentsDestroyResponses,
  TransparencyInstrumentsFetchMinimalCreateData,
  TransparencyInstrumentsFetchMinimalCreateResponses,
  TransparencyInstrumentsRetrieveData,
  TransparencyInstrumentsRetrieveResponses,
  TransparencyInstrumentsSearchCreateData,
  TransparencyInstrumentsSearchCreateResponses,
  TransparencyInstrumentsUnassociatedRetrieveData,
  TransparencyInstrumentsUnassociatedRetrieveResponses,
  TransparencyInstrumentsUpdateData,
  TransparencyInstrumentsUpdateResponses,
  TransparencyOrganizationsCreateData,
  TransparencyOrganizationsCreateResponses,
  TransparencyOrganizationsDestroyData,
  TransparencyOrganizationsDestroyResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
  TransparencyOrganizationsGetByIdentifierCreateData,
  TransparencyOrganizationsGetByIdentifierCreateResponses,
  TransparencyOrganizationsIsinsToNamesCreateData,
  TransparencyOrganizationsIsinsToNamesCreateResponses,
  TransparencyOrganizationsLogoCreateData,
  TransparencyOrganizationsLogoCreateResponses,
  TransparencyOrganizationsPartialUpdateData,
  TransparencyOrganizationsPartialUpdateResponses,
  TransparencyOrganizationsRetrieveData,
  TransparencyOrganizationsRetrieveResponses,
  TransparencyOrganizationsSearchCreateData,
  TransparencyOrganizationsSearchCreateResponses,
  TransparencyOrganizationsUpdateData,
  TransparencyOrganizationsUpdateResponses,
  TransparencyProposalsClassificationCodesRetrieveData,
  TransparencyProposalsClassificationCodesRetrieveResponses,
  TransparencyProposalsCountCreateData,
  TransparencyProposalsCountCreateResponses,
  TransparencyProposalsFetchCreateData,
  TransparencyProposalsFetchCreateResponses,
  TransparencyProposalsFetchNamesFromIdsCreateData,
  TransparencyProposalsFetchNamesFromIdsCreateResponses,
  TransparencyProposalsSecClassificationCodesRetrieveData,
  TransparencyProposalsSecClassificationCodesRetrieveResponses,
  TransparencyPublicSecurityIdsSearchCreateData,
  TransparencyPublicSecurityIdsSearchCreateResponses,
  VotingOperationsPiballotsFilterListData,
  VotingOperationsPiballotsFilterListResponses,
  VotingOperationsPimeetingsFilterListData,
  VotingOperationsPimeetingsFilterListResponses,
  VotingPolicyProviderVotingRecommendationsCreateData,
  VotingPolicyProviderVotingRecommendationsCreateResponses,
  VotingPolicyProviderVotingRecommendationsDestroyData,
  VotingPolicyProviderVotingRecommendationsDestroyResponses,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  VotingPolicyProviderVotingRecommendationsMatchCreateData,
  VotingPolicyProviderVotingRecommendationsMatchCreateResponses,
  VotingPolicyProviderVotingRecommendationsSearchCreateData,
  VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  VotingPolicyVotingPoliciesCreateData,
  VotingPolicyVotingPoliciesCreateResponses,
  VotingPolicyVotingPoliciesDestroyData,
  VotingPolicyVotingPoliciesDestroyResponses,
  VotingPolicyVotingPoliciesDocumentsCreateData,
  VotingPolicyVotingPoliciesDocumentsCreateResponses,
  VotingPolicyVotingPoliciesDocumentsListData,
  VotingPolicyVotingPoliciesDocumentsListResponses,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  VotingPolicyVotingPoliciesDocumentsRetrieveData,
  VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  VotingPolicyVotingPoliciesPartialUpdateData,
  VotingPolicyVotingPoliciesPartialUpdateResponses,
  VotingPolicyVotingPoliciesRetrieveData,
  VotingPolicyVotingPoliciesRetrieveResponses,
  VotingPolicyVotingPoliciesSearchCreateData,
  VotingPolicyVotingPoliciesSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsListData,
  VotingPolicyVotingPoliciesVotingRecommendationsListResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiSchemaRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiSchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema/',
    ...options,
  })

/**
 * Get task status
 *
 * Retrieve the current status and result of a background task by its ID.
 */
export const backgroundTasksTasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<BackgroundTasksTasksRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    BackgroundTasksTasksRetrieveResponses,
    BackgroundTasksTasksRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: backgroundTasksTasksRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/background-tasks/tasks/{task_id}/',
    ...options,
  })

/**
 * Export BetaNXT voter policies snapshot to S3
 *
 * Exports voter policies data to S3 as CSV. Includes holdings for the specified valid_time with policy selections. When multiple holdings exist for the same date, selects the most recent. Synchronous operation with 60s timeout. Requires timezone-aware datetime.
 */
export const directoutreachBetanxtVoterPolicySnapshotExportCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/directoutreach/betanxt/voter-policy-snapshot:export/',
      ...options,
    }
  )

/**
 * Create a new voting policy
 *
 * Creates a new voting policy with the provided information.
 */
export const directoutreachPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachPolicyCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List all available voting policies
 *
 * Retrieves a list of all voting available policies.
 */
export const directoutreachPolicyAvailableList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectoutreachPolicyAvailableListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DirectoutreachPolicyAvailableListResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableListResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/',
    ...options,
  })

/**
 * ViewSet for retrieving available voting policies.
 */
export const directoutreachPolicyAvailableRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyAvailableRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<DirectoutreachPolicyAvailableRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/{id}/',
    ...options,
  })

/**
 * Get voter's details
 *
 * Retrieves the details for the specified voter, including their ID and broker ID. Use 'mine' as the voter ID to get your own details.
 */
export const directoutreachVotersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersRetrieveResponses,
    DirectoutreachVotersRetrieveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/',
    ...options,
  })

/**
 * List latest voter's holdings
 *
 * Retrieves the holdings for the specified voter. Use 'mine' as the voter ID to get your own holdings.
 */
export const directoutreachVotersHoldingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersHoldingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersHoldingsRetrieveResponses,
    DirectoutreachVotersHoldingsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersHoldingsRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/holdings/',
    ...options,
  })

/**
 * Get voter's selected policy
 *
 * Retrieves the voting policy selected by the specified voter. Use 'mine' as the voter ID to get your own selected policy.
 */
export const directoutreachVotersSelectedPolicyRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersSelectedPolicyRetrieveResponses,
    DirectoutreachVotersSelectedPolicyRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
  })

/**
 * Create a new selected policy version
 *
 * Creates a new selected policy record for the specified voter. Use 'mine' as the voter ID to create your own selected policy.
 */
export const directoutreachVotersSelectedPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersSelectedPolicyCreateResponses,
    DirectoutreachVotersSelectedPolicyCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyCreateResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create voters with holdings (atomic)
 *
 * Atomically creates or updates multiple voters and their holdings.
 *
 * Each voter is identified by (mediant_id, broker_id). Holdings are created as new records, preserving complete historical data.
 */
export const directoutreachVotersBatchCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersBatchCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersBatchCreateCreateResponses,
    DirectoutreachVotersBatchCreateCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:batch-create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert voter with holdings
 *
 * Creates or updates a voter and creates new version of their holdings. Voters are identified by (mediant_id, broker_id). Each request creates new holding records, preserving complete historical data. Queries return only the latest version of each holding.
 *
 *
 */
export const directoutreachVotersCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachVotersCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachVotersCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund manager
 */
export const fundManagerFundManagersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundManagersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a fund manager
 */
export const fundManagerFundManagersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundManagersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
  })

/**
 * Update a fund manager
 */
export const fundManagerFundManagersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundManagersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund managers
 *
 * Search fund managers with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, relationship_owners) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundManagersSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundManagersSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundManagersSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund variant
 *
 * Creates a fund variant under the given parent fund. Public security IDs that don't yet exist are created automatically; custom security IDs must already exist. The fund variant must reference at least one public or custom security ID, and cash security IDs are rejected.
 */
export const fundManagerFundVariantsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundVariantsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund variant
 *
 * Deletes a fund variant, unlinking any security IDs that reference it.
 */
export const fundManagerFundVariantsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<FundManagerFundVariantsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Get a fund variant
 *
 * Returns a single fund variant by its id.
 */
export const fundManagerFundVariantsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundVariantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Update a fund variant
 *
 * Updates a fund variant's title, cfi and linked security IDs. Supplying a different `fund_name` reparents the variant onto that fund. Security IDs already linked to another variant are rejected with 409.
 */
export const fundManagerFundVariantsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundVariantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund variants
 *
 * Search fund variants with filters supplied in the request body. The parent fund filter is optional: omit `fund_name` to search across all funds (the wildcard parent 'funds/-'). Results are ordered by fund id, title, id. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundVariantsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundVariantsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundVariantsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund
 *
 * Creates a fund, including any proxy intermediary account identifiers supplied with it.
 */
export const fundManagerFundsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund quantification snapshot
 *
 * Creates an immutable fund quantification snapshot under the given fund, including the quantifications of the fund's variants supplied with it.
 */
export const fundManagerFundsQuantificationSnapshotsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsQuantificationSnapshotsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsQuantificationSnapshotsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{fund_id}/quantification-snapshots/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a fund
 *
 * Returns a fund. When the optional `product` query parameter is supplied, the fund is only returned if it belongs to that product; otherwise a 404 is returned.
 */
export const fundManagerFundsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
  })

/**
 * Update a fund
 *
 * Updates a fund. The product and fund manager of a fund cannot be changed. When proxy intermediary identifiers are supplied, the fund's proxy intermediary accounts are synced to match them; when omitted (or null), existing accounts are left untouched.
 */
export const fundManagerFundsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search funds
 *
 * Search funds with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, external_ids, account ids) are sent in the body to avoid overflowing URL-length limits. Results are ordered by create time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List providers
 */
export const fundManagerProvidersList = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerProvidersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<FundManagerProvidersListResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
  })

/**
 * Create a provider
 */
export const fundManagerProvidersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerProvidersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a provider
 */
export const fundManagerProvidersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerProvidersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
  })

/**
 * Update a provider
 */
export const fundManagerProvidersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerProvidersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund quantification snapshots
 *
 * Search fund quantification snapshots with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, fund_names) are sent in the body to avoid overflowing URL-length limits. Results are ordered by valid time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerQuantificationSnapshotsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerQuantificationSnapshotsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerQuantificationSnapshotsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/quantification-snapshots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List meetings with filtering and cursor pagination.
 */
export const institutionalMeetingsearchList = <ThrowOnError extends boolean = false>(
  options: Options<InstitutionalMeetingsearchListData, ThrowOnError>
) =>
  (options.client ?? client).get<InstitutionalMeetingsearchListResponses, unknown, ThrowOnError>({
    responseTransformer: institutionalMeetingsearchListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/institutional/meetingsearch',
    ...options,
  })

/**
 * Assign a category to a proposal
 *
 * Assigns a proxy intermediary's free-text category to a transparency proposal, creating the category if none exists for the (proxy intermediary, proposal) pair or updating it otherwise.
 */
export const proxyIntermediaryProposalCategoriesAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List categories for proposals
 *
 * Lists the proposal categories matching the given proxy intermediaries and transparency proposals. Filters are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalCategoriesListCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesListCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesListCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/list/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Assign a label to a proposal
 *
 * Assigns a proxy intermediary's label to a transparency proposal. An empty label deletes any existing label for the proposal; a non-empty label creates or updates it. The label must be unique per (proxy intermediary, transparency general meeting) pair.
 */
export const proxyIntermediaryProposalLabelsAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch labels for proposals
 *
 * Fetches the labels and categories for the given transparency proposals and proxy intermediary. Proposals without a label are omitted from the response maps. Proposal names are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalLabelsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsFetchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediaries
 *
 * Search proxy intermediaries with filters supplied in the request body. Filters that may contain large, unbounded collections (names, titles) are sent in the body to avoid overflowing URL-length limits. Absent or empty filters return all proxy intermediaries. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediariesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediariesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryProxyIntermediariesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediaries/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List ballot entitlements
 *
 * Returns ballot entitlements, optionally filtered by proxy_intermediary_ballot_id or investor_account_id. By default, only active entitlements (invalid_time is null) are returned. Set include_invalid=true to include invalidated entitlements.
 */
export const proxyvotingEntitlementsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingEntitlementsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingEntitlementsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingEntitlementsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements',
    ...options,
  })

/**
 * Compute ballot breakdown synchronously
 *
 * Computes the ballot breakdown for a proxy intermediary ballot with specified filters. Returns the full graph structure in JSON format. This is a synchronous operation.
 */
export const proxyvotingEntitlementsBreakdownCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsBreakdownCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsBreakdownCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements/breakdown',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Trigger entitlements computation
 *
 * Enqueues an entitlements computation task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingEntitlementsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Fund Manager Supported Issued Instruments
 *
 * Updates a fund manager's Supported Issued Instruments for the given voting policies and ISINs. Adds new instruments and invalidates existing instruments not in the provided list.
 */
export const proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create fund manager policy supported issued instruments
 *
 * Creates fund manager policy supported issued instruments for the given fund manager and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete fund manager policy supported issued instruments
 *
 * Soft-deletes fund manager policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund manager policy supported issued instruments
 *
 * Search fund manager policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. fund_manager_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List fund manager supported policies
 *
 * Returns all fund manager / voting policy links, optionally filtered. Supply as_of to fetch the historical state at a specific point in time.
 */
export const proxyvotingFundManagerSupportedPoliciesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingFundManagerSupportedPoliciesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingFundManagerSupportedPoliciesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
  })

/**
 * Batch upsert fund manager supported policies
 *
 * Creates or ensures existence of fund manager / voting policy links. All upserts are applied atomically.
 */
export const proxyvotingFundManagerSupportedPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingFundManagerSupportedPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund manager supported policy
 *
 * Deletes the fund manager / voting policy link with the given ID.
 */
export const proxyvotingFundManagerSupportedPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingFundManagerSupportedPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies/{id}',
    ...options,
  })

/**
 * Get composition differences
 *
 * Fetches and compares investor compositions between two time periods
 */
export const proxyvotingInvestorCompositionsDifferenceList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsDifferenceListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsDifferenceListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/difference',
    ...options,
  })

export const proxyvotingInvestorCompositionsRenderCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRenderCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorCompositionsRenderCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/render',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get investor rules engine mapping
 *
 * Retrieves the rules engine mapping for a specific investor. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
  })

/**
 * Map investor to rules engine
 *
 * Upserts mapping between an investor and their voting rules engine. Returns 201 for new mappings, 200 for updates. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingInvestorCompositionsRulesEngineUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Supported Issued Instruments from composition difference
 *
 * Updates an investor's Supported Issued Instruments based on a provided composition difference. Adds new instruments and invalidates removed instruments.
 */
export const proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create investor policy supported issued instruments
 *
 * Creates investor policy supported issued instruments for the given investor and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor policy supported issued instruments
 *
 * Soft-deletes investor policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor policy supported issued instruments
 *
 * Search investor policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Batch create investor supported issued instruments
 *
 * Creates investor supported issued instruments for the given investor. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor supported issued instruments
 *
 * Soft-deletes investor supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor supported issued instruments
 *
 * Search investor supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List meeting ballot sources
 *
 * Returns meeting ballot sources, optionally filtered by meeting_ballot_id or proxy_intermediary_ballot_id. By default, only active sources (invalid_time is null) are returned. Set include_invalid=true to include invalidated sources.
 */
export const proxyvotingMeetingBallotSourcesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotSourcesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotSourcesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotSourcesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballot-sources',
    ...options,
  })

/**
 * List meeting ballots
 *
 * Returns meeting ballots, optionally filtered by investor_id or general_meeting_id.
 */
export const proxyvotingMeetingBallotsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballots',
    ...options,
  })

/**
 * Trigger meeting ballot handout processing
 *
 * Enqueues a meeting ballot handout task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingMeetingballotsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingMeetingballotsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingMeetingballotsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meetingballots:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const proxyvotingPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/filter',
    ...options,
  })

/**
 * Compute investor accounts who can vote on ballots, and whether investigation is required the ballot
 *
 * For each provided ballot ID, returns the number of investor accounts expected to vote, their individual fund proportions, and whether the ballot requires investigation due to potentially missing or inaccurate entitlements data.
 */
export const proxyvotingPiballotsInvestorsCanVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingPiballotsInvestorsCanVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingPiballotsInvestorsCanVoteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/investors-can-vote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const proxyvotingPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/pimeetings/filter',
    ...options,
  })

/**
 * List rules engine definitions
 *
 * Returns all rules engine definition versions, optionally filtered by name.
 */
export const proxyvotingRulesEngineDefinitionsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
  })

/**
 * Create a rules engine definition
 *
 * Creates a new rules engine definition version.
 */
export const proxyvotingRulesEngineDefinitionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List rules for a definition
 *
 * Returns all rules for the given rules engine definition, ordered by rule order.
 */
export const proxyvotingRulesEngineDefinitionsRulesList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRulesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
  })

/**
 * Create a rule
 *
 * Creates a new rule within the given rules engine definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsRulesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rule
 *
 * Deletes the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsRulesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
  })

/**
 * Update a rule
 *
 * Replaces all fields of the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingRulesEngineDefinitionsRulesUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rules engine definition
 *
 * Deletes the definition with the given ID and its associated rules. Returns 409 if this is the last definition for its name — use DELETE /rules-engine-definitions/by-name/{name} to delete the engine entirely.
 */
export const proxyvotingRulesEngineDefinitionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsDestroyResponses,
    ProxyvotingRulesEngineDefinitionsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Retrieve a rules engine definition
 *
 * Returns the rules engine definition with the given ID.
 */
export const proxyvotingRulesEngineDefinitionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Delete all definitions for a name
 *
 * Deletes all versioned definitions with the given name and their associated rules. Returns 409 if the name is the Tumelo base engine or if any investor is configured to use this rules engine. Returns 404 if no definitions exist with the given name.
 */
export const proxyvotingRulesEngineDefinitionsByNameDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsByNameDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
    ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/by-name/{name}',
    ...options,
  })

/**
 * List rules engine names
 *
 * Returns the distinct names of all rules engines, sorted alphabetically. Use this to render a list of available rules engines before fetching their versions.
 */
export const proxyvotingRulesEngineDefinitionsNamesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsNamesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/names',
    ...options,
  })

/**
 * Create a new Split Vote Instruction Proposal Overwrite.
 */
export const proxyvotingSviProposalOverwriteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingSviProposalOverwriteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingSviProposalOverwriteCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingSviProposalOverwriteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Retrieve a list of Split Vote Instruction Overwrite Reasons.
 */
export const proxyvotingSviProposalOverwriteReasonsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingSviProposalOverwriteReasonsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingSviProposalOverwriteReasonsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite/reasons',
    ...options,
  })

/**
 * Search audit events
 *
 * Search audit events with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. audit_event_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyAuditEventsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyAuditEventsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyAuditEventsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyAuditEventsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/audit-events/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an external meeting ID
 */
export const transparencyExternalMeetingIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyExternalMeetingIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyExternalMeetingIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an external meeting ID
 */
export const transparencyExternalMeetingIdsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyExternalMeetingIdsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/{id}/',
    ...options,
  })

/**
 * Create a general meeting
 */
export const transparencyGeneralMeetingsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyGeneralMeetingsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a general meeting by ID
 */
export const transparencyGeneralMeetingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyGeneralMeetingsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
  })

/**
 * Update a general meeting (partial update)
 */
export const transparencyGeneralMeetingsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyGeneralMeetingsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search general meetings
 *
 * Search general meetings with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. general_meeting_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyGeneralMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyGeneralMeetingsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyGeneralMeetingsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an instrument
 *
 * Creates an instrument, validated as defined by the instrument resource.
 */
export const transparencyInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an instrument
 *
 * Deletes the instrument.
 */
export const transparencyInstrumentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyInstrumentsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Get an instrument by ISIN
 *
 * Returns an instrument by its identifier, the ISIN.
 */
export const transparencyInstrumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyInstrumentsRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Replace an instrument
 *
 * Replaces every field on the instrument.
 */
export const transparencyInstrumentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyInstrumentsUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the minimal projection of many instruments at once
 *
 * Fetches instruments given a list of ISINs. Designed to be more performant than the list endpoint when only a subset of fields is needed.
 */
export const transparencyInstrumentsFetchMinimalCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsFetchMinimalCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsFetchMinimalCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/fetch-minimal/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search instruments
 *
 * Search instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyInstrumentsSearchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List non-composite instruments not linked to any organization
 *
 * Returns the non-composite instruments which do not have an association to an organization.
 */
export const transparencyInstrumentsUnassociatedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsUnassociatedRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyInstrumentsUnassociatedRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/unassociated/',
    ...options,
  })

/**
 * Create an organization
 */
export const transparencyOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an organization
 */
export const transparencyOrganizationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyOrganizationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Get an organization by ID
 */
export const transparencyOrganizationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyOrganizationsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Patch an organization (partial update)
 */
export const transparencyOrganizationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyOrganizationsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Replace an organization (full update)
 */
export const transparencyOrganizationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyOrganizationsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upload a new logo for an organization
 */
export const transparencyOrganizationsLogoCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsLogoCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsLogoCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsLogoCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/logo/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proposal
 */
export const transparencyOrganizationsGeneralMeetingsProposalsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a proposal by ID
 */
export const transparencyOrganizationsGeneralMeetingsProposalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
  })

/**
 * Partially update a proposal (merges over the current version)
 *
 * Updates only the fields supplied in the request, preserving all others from the proposal's current version. Creates a new version, invalidating the previous one.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a proposal (full replace of current version)
 */
export const transparencyOrganizationsGeneralMeetingsProposalsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proposals within a general meeting
 *
 * Search proposals with filters supplied in the request body. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Look up an organization by external identifier
 */
export const transparencyOrganizationsGetByIdentifierCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGetByIdentifierCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsGetByIdentifierCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/get-by-identifier/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Resolve a batch of ISINs to organization names
 */
export const transparencyOrganizationsIsinsToNamesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsIsinsToNamesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsIsinsToNamesCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/isins-to-names/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search organizations
 *
 * Search organizations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyOrganizationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyOrganizationsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List proposal classification codes
 */
export const transparencyProposalsClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/classification-codes/',
    ...options,
  })

/**
 * Count proposals per general meeting
 */
export const transparencyProposalsCountCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsCountCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsCountCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/count/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposals across multiple general meetings
 *
 * Fetch proposals across multiple general meetings with optional votability filters. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyProposalsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyProposalsFetchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposal resource names from identity UUIDs
 */
export const transparencyProposalsFetchNamesFromIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchNamesFromIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchNamesFromIdsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch-names-from-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List SEC proposal category codes
 */
export const transparencyProposalsSecClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsSecClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsSecClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/sec-classification-codes/',
    ...options,
  })

/**
 * Search public security IDs
 *
 * Search public security IDs with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, values) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyPublicSecurityIdsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyPublicSecurityIdsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyPublicSecurityIdsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyPublicSecurityIdsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/public-security-ids/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const votingOperationsPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/piballots/filter',
    ...options,
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const votingOperationsPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/pimeetings/filter',
    ...options,
  })

/**
 * Create a provider voting recommendation
 *
 * Creates a provider voting recommendation. Validates that the parent voting policy exists. Returns 409 Conflict if an identical recommendation already exists.
 */
export const votingPolicyProviderVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a provider voting recommendation
 *
 * Soft-deletes a provider voting recommendation by setting its delete_time.
 */
export const votingPolicyProviderVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyProviderVotingRecommendationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/{id}/',
    ...options,
  })

/**
 * Match a provider voting recommendation to a proposal
 *
 * Creates a voting recommendation for a proposal from this provider voting recommendation (PVR), copying the PVR's instruction, rationale, proposal text/label/sequence number and id. The parent voting policy is taken from the PVR. Validates that the proposal exists, the instruction is valid for it, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead. If the PVR carries an external_meeting_id, a best-effort external meeting id mapping is created.
 */
export const votingPolicyProviderVotingRecommendationsMatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsMatchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsMatchCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/voting-policy/provider-voting-recommendations/{id}/match/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * Fetch provider voting recommendations by version
 *
 * Returns all non-deleted provider voting recommendations for a specific meeting+policy batch version, identified by unique_meeting_policy_id and meeting_batch_version. The result is not paginated.
 */
export const votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/fetch-by-version/',
    ...options,
  })

/**
 * Search provider voting recommendations
 *
 * Searches provider voting recommendations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, policy_ids) are sent in the body to avoid overflowing URL-length limits. Soft-deleted recommendations are always excluded. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const votingPolicyProviderVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProviderVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a voting policy
 *
 * Creates a voting policy. The id is server-generated. `available_to_investor_type` must contain at least one investor type. If supplied, `image_url` must be a Cloudinary URL.
 */
export const votingPolicyVotingPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting policy
 *
 * Deletes a voting policy and cascades deletion of its policy documents (DB + S3). Returns 409 Conflict if any voting recommendations exist for the policy.
 */
export const votingPolicyVotingPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyVotingPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Get a voting policy
 *
 * Returns a single voting policy by its UUID, with the most recent voting policy document attached as `current_policy_document` (null if the policy has no documents).
 */
export const votingPolicyVotingPoliciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Update a voting policy
 *
 * Partially updates a voting policy. Only fields present in the request body are updated; absent fields are left untouched.
 */
export const votingPolicyVotingPoliciesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List voting policy documents
 *
 * Returns voting policy documents for a given voting policy, ordered by issue time descending. Supports pagination.
 */
export const votingPolicyVotingPoliciesDocumentsList = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsListData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
  })

/**
 * Create a voting policy document
 *
 * Uploads a PDF and creates a document record for a voting policy. The request body must be the raw PDF file with Content-Type: application/pdf. The file must not exceed 10 MB. The issue_time must not be in the future.
 */
export const votingPolicyVotingPoliciesDocumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesDocumentsCreateResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    responseTransformer: votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
    headers: {
      'Content-Type': 'application/pdf',
      ...options.headers,
    },
  })

/**
 * Get a voting policy document
 *
 * Returns a single voting policy document by its integer ID.
 */
export const votingPolicyVotingPoliciesDocumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
  })

/**
 * Update a voting policy document
 *
 * Partially updates a voting policy document. Only title and issue_time may be changed.
 */
export const votingPolicyVotingPoliciesDocumentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List voting recommendations
 *
 * Returns the current voting recommendations for a given voting policy, one per proposal. Supports filtering by proposal name and provider recommendation ID. Results are cursor-paginated.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsList = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsListData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesVotingRecommendationsListResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/',
    ...options,
  })

/**
 * Create a voting recommendation
 *
 * Creates a voting recommendation for a proposal under the given voting policy. Validates that the proposal exists, the voting instruction is valid for that proposal, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting recommendation
 *
 * Soft-deletes a voting recommendation.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Get a voting recommendation
 *
 * Returns a single voting recommendation by its version ID.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Update a voting recommendation
 *
 * Updates a voting recommendation's voting_instruction and/or rationale. Creates a new version of the recommendation, invalidating the previous one. Re-validates the voting instruction and proxy deadline on each update. Returns 409 Conflict if no fields change, leaving the current version active.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a voting recommendation from a provider voting recommendation
 *
 * Updates an existing voting recommendation from a provider voting recommendation (PVR), creating a new version. Copies the PVR's voting_instruction, rationale, proposal_sequence_number and id onto the new version; proposal_name, proposal_text and proposal_label are preserved. Re-validates the voting instruction and proxy deadline. Returns 404 if the voting recommendation or the PVR does not exist.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/update-from-pvr/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting recommendations
 *
 * Searches the current voting recommendations for a voting policy, one per proposal, with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. proposal_names) are sent in the body to avoid overflowing URL-length limits. Results are cursor-paginated.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting policies
 *
 * Searches voting policies with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. voting_policy_ids) are sent in the body to avoid overflowing URL-length limits. Results include the most recent voting policy document per policy (null if none exist).
 */
export const votingPolicyVotingPoliciesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyVotingPoliciesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<VotingPolicyVotingPoliciesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a voting recommendation confidence score
 *
 * Creates or replaces the validation confidence score for a voting recommendation version. The confidence score must be between 0.0 and 1.0. Returns 201 when a new score is created and 200 when an existing score is updated.
 */
export const votingPolicyVotingRecommendationConfidenceScoresUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingRecommendationConfidenceScoresUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-recommendation-confidence-scores/{version_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
